var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import * as React from "react";
import { AUTH_STATUS, NOT_INSURED_ISSUER_SLUG, SUPPORTED_HOMEOWNERS_ISSUERS, notInsuredIssuer, otherIssuer, } from "../../lib/constants";
import { EXPERIENCE, InsuranceProducts, InsuranceType } from "../../constants";
import { PHASE } from "../../routeConfig";
import { PivotReason, prefillUserSelectedOtherIssuer, selectHomeIssuer, } from "../../features/applicant/applicantSlice";
import { clickedNoInsurance, clickedOtherIssuer, completedPage, } from "../../lib/Avo";
import AppBody from "../../components/AppBody";
import Header from "../../components/Header";
import RouteHeaderLogo from "../../components/RouteHeaderLogo";
import SelectIssuerList from "../../components/SelectIssuerList";
import { SupportedIssuers } from "@trellisconnect/types/dist/src/enums/SupportedIssuers";
import { batch } from "react-redux";
import { enteredUnlinkedApplication } from "../../features/unlinked-application/unlinkedApplicationSlice";
import { updateCommonAnalyticProperty } from "../../features/analytics/analyticsSlice";
import useAppDispatch from "../../hooks/useAppDispatch";
import useAppSelector from "../../hooks/useAppSelector";
import useCanShowMidFunnelAds from "../../features/configuration/useCanShowMidFunnelAds";
import { useGetIssuersQuery } from "../../services/savvy";
import { useHistory } from "react-router-dom";
import useIsFlagOn from "../../features/feature-flags/hooks/useIsFlagOn";
import useIsSupportedIssuer from "../../hooks/useIsSupportedIssuer";
import useUnlinkedApplicationEntryRoute from "../../features/unlinked-application/useUnlinkedApplicationEntryRoute";
function isHomeownerIssuer(issuer) {
    return SUPPORTED_HOMEOWNERS_ISSUERS.includes(issuer.id);
}
export default function SelectHomeIssuerRoute() {
    var currentAutoIssuer = useAppSelector(function (state) { return state.applicant.currentIssuer.auto; });
    var shoppingIntent = useAppSelector(function (state) { return state.applicant.insuranceProduct; });
    var _a = useAppSelector(function (state) { return state.configuration; }), products = _a.products, enableFormExperience = _a.enableFormExperience;
    var commonAnalyticsProperties = useAppSelector(function (state) { return state.analytics.commonAnalyticsProperties; });
    var dispatch = useAppDispatch();
    var push = useHistory().push;
    var authAutoStatus = useAppSelector(function (state) { return state.auth.auto.status; });
    var _b = useGetIssuersQuery(undefined, {
        selectFromResult: function (_a) {
            var data = _a.data;
            return {
                issuers: data === null || data === void 0 ? void 0 : data.filter(function (issuer) {
                    return isHomeownerIssuer(issuer) || (currentAutoIssuer === null || currentAutoIssuer === void 0 ? void 0 : currentAutoIssuer.id) === issuer.id;
                }),
            };
        },
    }).issuers, issuerList = _b === void 0 ? [] : _b;
    var isSupportedIssuer = useIsSupportedIssuer();
    var canShowMidFunnelAds = useCanShowMidFunnelAds();
    var unlinkedEntranceRoute = useUnlinkedApplicationEntryRoute(InsuranceType.Home);
    var isAutoOnlyOwnHomePivot = useAppSelector(function (state) { return state.applicant.bundlePivotReason === PivotReason.OwnHome; });
    var isPrefillUser = useAppSelector(function (state) { return state.configuration.experience === EXPERIENCE.PREFILL; });
    var isConnectEnabled = useIsFlagOn("onboard_connect_frontend");
    var isCurrentAutoIssuerKnown = (currentAutoIssuer === null || currentAutoIssuer === void 0 ? void 0 : currentAutoIssuer.id) &&
        [otherIssuer.id, NOT_INSURED_ISSUER_SLUG].includes(currentAutoIssuer.id) ===
            false;
    var currentAutoIssuerIsSupportedHomeowners = isCurrentAutoIssuerKnown
        ? SUPPORTED_HOMEOWNERS_ISSUERS.includes(currentAutoIssuer.id)
        : false;
    var initialIssuers = __spreadArray(__spreadArray([], SUPPORTED_HOMEOWNERS_ISSUERS, true), [
        isCurrentAutoIssuerKnown && !currentAutoIssuerIsSupportedHomeowners
            ? currentAutoIssuer === null || currentAutoIssuer === void 0 ? void 0 : currentAutoIssuer.id
            : undefined,
    ], false).filter(function (issuer) { return typeof issuer === "string"; })
        .sort(function (a, b) {
        if (a === SupportedIssuers.DEMO ||
            (a === (currentAutoIssuer === null || currentAutoIssuer === void 0 ? void 0 : currentAutoIssuer.id) && b !== SupportedIssuers.DEMO))
            return -1;
        if (b === SupportedIssuers.DEMO ||
            (b === (currentAutoIssuer === null || currentAutoIssuer === void 0 ? void 0 : currentAutoIssuer.id) && a !== SupportedIssuers.DEMO))
            return 1;
        return 0;
    });
    /**
     * For the MVP the only two viable options are either disclaimer for home-only linking
     * or the Home Unlinked Application. There is no double linking or other way to get into the
     * home linking flow without selecting home only product interest
     */
    function getNextRoute(issuer) {
        var supportedIssuer = isSupportedIssuer(issuer);
        var isInsured = issuer.id !== NOT_INSURED_ISSUER_SLUG;
        var defaultNextRoute = PHASE.HOME_HAVE_LOGIN;
        var homeProductSelected = shoppingIntent === InsuranceProducts.Home ||
            (products.length === 1 && products[0] === InsuranceProducts.Home);
        var nextRoute;
        if (homeProductSelected) {
            if (isConnectEnabled && supportedIssuer && isInsured) {
                nextRoute = defaultNextRoute;
            }
            else {
                if (enableFormExperience) {
                    nextRoute = unlinkedEntranceRoute;
                }
                else if (canShowMidFunnelAds) {
                    nextRoute = PHASE.HOME_MID_FUNNEL_ADS;
                }
                else if (!isInsured) {
                    nextRoute = PHASE.HOME_UNQUALIFIED;
                }
                else {
                    nextRoute = PHASE.HOME_UNSUPPORTED;
                }
            }
        }
        else {
            // what if forms are disabled ????
            if (authAutoStatus === AUTH_STATUS.SUCCESS) {
                nextRoute = unlinkedEntranceRoute;
            }
            else {
                nextRoute = isAutoOnlyOwnHomePivot
                    ? PHASE.UNLINKED_APPLICATION_HOMEOWNERS_PREMIUM
                    : PHASE.UNLINKED_APPLICATION_HOMEOWNERS_PROPERTY_ADDRESS;
            }
        }
        if (!nextRoute) {
            nextRoute = defaultNextRoute;
        }
        return { nextRoute: nextRoute, supportedIssuer: supportedIssuer, isInsured: isInsured };
    }
    function handleSelectIssuer(issuer, triggerEvent) {
        if (triggerEvent === void 0) { triggerEvent = true; }
        var _a = getNextRoute(issuer), nextRoute = _a.nextRoute, supportedIssuer = _a.supportedIssuer, isInsured = _a.isInsured;
        if (triggerEvent) {
            completedPage(__assign(__assign({}, commonAnalyticsProperties), { selectedOption: issuer.name, optionSelected: issuer.name }));
        }
        batch(function () {
            dispatch(selectHomeIssuer(issuer));
            if (issuer.id === otherIssuer.id && isPrefillUser) {
                dispatch(prefillUserSelectedOtherIssuer({ home: true }));
            }
            if (!supportedIssuer) {
                dispatch(enteredUnlinkedApplication("unsupported-issuer"));
            }
            if (!isInsured) {
                dispatch(enteredUnlinkedApplication("not-insured"));
            }
        });
        push(nextRoute);
    }
    function handleIssuerIsNotListed(ev) {
        var nextRoute = getNextRoute(otherIssuer).nextRoute;
        clickedOtherIssuer(commonAnalyticsProperties);
        completedPage(__assign(__assign({}, commonAnalyticsProperties), { selectedOption: ev.currentTarget.textContent, optionSelected: ev.currentTarget.textContent }));
        dispatch(selectHomeIssuer(otherIssuer));
        dispatch(enteredUnlinkedApplication("unsupported-issuer"));
        push(nextRoute);
    }
    React.useEffect(function () {
        if (!commonAnalyticsProperties.shoppingIntent) {
            dispatch(updateCommonAnalyticProperty({
                shoppingIntent: InsuranceProducts.Home,
            }));
        }
    }, [commonAnalyticsProperties.shoppingIntent, dispatch]);
    return (React.createElement(React.Fragment, null,
        React.createElement(Header, null,
            React.createElement(RouteHeaderLogo, null)),
        React.createElement(AppBody, null,
            React.createElement(SelectIssuerList, { title: "Who insures your home today?", issuerListLastNode: function () {
                    return (React.createElement(React.Fragment, null,
                        React.createElement("button", { className: "py-4 text-center font-bold text-trellis-black underline", onClick: handleIssuerIsNotListed }, "My insurer is not listed"),
                        React.createElement("button", { className: "py-4 text-center font-bold text-trellis-black underline", onClick: function (ev) {
                                clickedNoInsurance(commonAnalyticsProperties);
                                completedPage(__assign(__assign({}, commonAnalyticsProperties), { selectedOption: ev.currentTarget.textContent, optionSelected: ev.currentTarget.textContent }));
                                handleSelectIssuer(notInsuredIssuer, false);
                            } }, "My home is not insured")));
                }, insuranceType: InsuranceType.Home, disableSearchBox: true, issuers: issuerList, initialIssuers: initialIssuers, handleSelectIssuer: handleSelectIssuer, onFooterClick: function (ev) {
                    clickedOtherIssuer(commonAnalyticsProperties);
                    completedPage(__assign(__assign({}, commonAnalyticsProperties), { optionSelected: ev.currentTarget.textContent, selectedOption: ev.currentTarget.textContent }));
                    handleSelectIssuer(otherIssuer, false);
                } }))));
}
